"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import GroupCardDeleteModal from "./GroupCardDeleteModal";
export default function GroupCardDelete(t0) {
  const $ = _c(6);
  const {
    group
  } = t0;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <button onClick={e => {
      e.stopPropagation();
      setIsDeleteModalOpen(true);
    }} className="tw-bg-transparent tw-w-full tw-border-none tw-block tw-px-3 tw-py-1 tw-text-sm tw-leading-6 tw-text-iron-300 hover:tw-text-iron-50 hover:tw-bg-iron-800 tw-text-left tw-transition tw-duration-300 tw-ease-out" role="menuitem" tabIndex={-1} id="options-menu-0-item-1">Delete</button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== group || $[2] !== isDeleteModalOpen) {
    t2 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><GroupCardDeleteModal group={group} onClose={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[1] = group;
    $[2] = isDeleteModalOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div>{t1}<CommonAnimationWrapper mode="sync" initial={true}>{t2}</CommonAnimationWrapper></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(e_0) {
  return e_0.stopPropagation();
}